import React from "react";

interface CityListProps {
  onCitySelect: (city: string) => void;
  cities: any;
}

const CityList: React.FC<CityListProps> = ({
  onCitySelect,
  cities,
}) => {
  return (
    <ul className="flex flex-col mt-6 w-full text-gray-500">
      {cities.map((city: any, index: number) => (
        <li key={index} className={index > 0 ? "mt-6" : ""}>
          <button
            onClick={() => onCitySelect(city)}
            className="text-left w-full hover:text-indigo-600 focus:outline-none focus:text-indigo-600"
          >
            {city?.cityName}, {city?.state}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default CityList;
